import { ROUTES } from './routing'

import {
  accessControlSubNavigationWithUserTypes,
  accessControlStatus,
} from 'setups/controller'
import { projectClient } from 'constants/project'
import { UserTypeNames } from 'setups/usertypes'

export const SubsquadTabModulesData = [
  {
    module: 'Member',
    route: {
      title: 'Members',
      path: ROUTES.MerchantProfileTransactions,
      pathname: 'members',
      className:
        'text-black py-2 mx-3 block hover:text-primary focus:font-bold focus:outline-none',
    },
  },
]

export const SUBSQUADTABSNAVIGATION_FN = (
  userType: string,
  navModule: string,
  thorUserStatus: string
) => {
  const checkAccessViaHDAUser = accessControlSubNavigationWithUserTypes({
    projectClient,
    navModules: SubsquadTabModulesData,
    navModule: 'subsquad',
    userType: userType as UserTypeNames,
    isTempBypass: false,
  })
  return thorUserStatus
    ? accessControlStatus(checkAccessViaHDAUser, navModule, thorUserStatus)
    : checkAccessViaHDAUser
}
